<template>
  <div>
    <div class="queue-navbar">
      <div class="d-flex">
        <div class="v-center circle">
          <img class="cafe-logo" :src="cafe.image || '/icons/cafe-logo-placeholder.jpg'" alt="Cafe Logo" />
        </div>
        <div class="caffe-info">
          <h4 class="m-0 waiter color-white">{{ waiter.name }}</h4>
          <span class="cafe color-grey">{{ cafe.name }}</span>
        </div>
      </div>
      <div class="nav-info">
        <p class="caffe-name">{{ cafe.name }}</p>
        <p class="queue" v-if="sharedTime == 0">
          {{ $t("queue.shared_queue") }}
        </p>
        <p class="queue" v-if="sharedTime > 0">{{ waiter.name }}</p>
        <p class="tick" v-if="sharedTime > 0">
          <font-awesome-icon icon="clock" />
          {{ sharedTime }}
        </p>
      </div>
      <div class="v-center">
        <div class="box-alert" v-if="notificationsCounter">
          {{ notificationsCounter }}
        </div>
        <img
          :src="!isMenuActive ? '/icons/menu-list.svg' : '/icons/del.svg'"
          class="menu-list"
          @click="toggleMenu()"
        />
      </div>
    </div>

    <div :class="'list list-slide'" v-show="isMenuActive">
      <img class="list-logo" src="../assets/logo-white.png" alt="Logo " />
      <ul>
        <li
          @click="emitDesktopNavigate('inside')"
          :class="currentMode == 'inside' ? 'color-white' : 'desktop-dark'"
          to="/list"
          tag="li"
          v-if="isDesktop && cafe.modes.inside && !cafe.inside_lite"
        >
          INSIDE
          <div class="box-alert link" v-if="pendingCounters.inside">
            {{ pendingCounters.inside }}
          </div>
        </li>
        <li
          :class="currentMode == 'preorder' ? 'color-white' : 'desktop-dark'"
          to="/preorder"
          tag="li"
          @click="emitDesktopNavigate('preorder')"
          v-if="isDesktop && cafe.modes.preorder"
        >
          TAKEAWAY
          <div v-if="pendingCounters.preorder" class="box-alert link">
            {{ pendingCounters.preorder }}
          </div>
        </li>
        <li
          @click="emitDesktopNavigate('delivery')"
          :class="currentMode == 'delivery' ? 'color-white' : 'desktop-dark'"
          to="/delivery"
          tag="li"
          v-if="isDesktop && cafe.modes.delivery"
        >
          DELIVERY
          <div v-if="pendingCounters.delivery" class="box-alert link">
            {{ pendingCounters.delivery }}
          </div>
        </li>
        <router-link
          class="color-grey"
          to="/orders"
          tag="li"
          v-if="!isDesktop"
          >{{ $t("navbar.orders") }}</router-link
        >
        <router-link
          class="desktop-dark"
          active-class="active-link"
          to="/stoplist"
          tag="li"
          >{{ $t("navbar.stoplist") }}</router-link
        >

        <router-link
          class="desktop-dark"
          active-class="active-link"
          to="/tables"
          tag="li"
          v-if="canShowTables && !isHotel"
          >{{ $t("navbar.tables") }}</router-link
        >
        <router-link
          class="desktop-dark"
          active-class="active-link"
          to="/notifications"
          tag="li"
        >
          {{ $t("navbar.notifs") }}
          <div v-if="notificationsCounter" class="box-alert link">
            {{ notificationsCounter }}
          </div>
        </router-link>
        <router-link
          class="desktop-dark"
          active-class="active-link"
          to="/archive"
          tag="li"
          >{{ $t("navbar.archive") }}</router-link
        >
        <a href="#" @click.prevent="openNewVersion">
          <li class="desktop-dark">{{ $t("navbar.switch_new") }}</li>
        </a>
        <a href="#" @click.prevent="toggleIntercom">
          <li class="desktop-dark">{{ $t("navbar.support") }}</li>
        </a>
      </ul>
      <div
        class="locale-image-div"
        style="margin-top:3.1vh; display:inline-block"
      >
        <img
          class="locale-image"
          src="/flags/en.png"
          alt="EN Locale Flag"
          @click="localeShow()"
          v-if="!showLocale && this.$i18n.locale == 'en'"
        />
        <img
          class="locale-image"
          src="/flags/uk.png"
          alt="EN Locale Flag"
          @click="localeShow()"
          v-if="!showLocale && this.$i18n.locale == 'uk'"
        />
        <img
          class="locale-image"
          src="/flags/ru.png"
          alt="EN Locale Flag"
          @click="localeShow()"
          v-if="!showLocale && this.$i18n.locale == 'ru'"
        />
        <div class="otherLocale" v-if="showLocale">
          <img
            class="locale-image"
            src="/flags/en.png"
            alt="EN Locale Flag"
            @click="switchLocale('en'), (showLocale = false)"
          />
          <img
            class="locale-image"
            src="/flags/uk.png"
            alt="UK Locale Flag"
            @click="switchLocale('uk'), (showLocale = false)"
          />
          <img
            class="locale-image"
            src="/flags/ru.png"
            alt="RU Locale Flag"
            @click="switchLocale('ru'), (showLocale = false)"
          />
        </div>
      </div>
      <div class="exit" @click="logout">
        <span class="color-white float-right">{{ $t("navbar.logout") }}</span>
      </div>
      <div class="desktop-nav-info">
        <div class="caffe-name-info">
          <h4>{{ cafe.name }}</h4>
          <p>{{ waiter.name }}</p>
        </div>
        <!-- <div class="line"></div> -->
        <!-- <div class="timer" v-if="!sharedTime">(10 с.)</div> -->
        <!-- <div class="timer" v-if="sharedTime">({{ sharedTime }} с.)</div> -->
      </div>
      <!-- <div class="line"></div> -->
    </div>
  </div>
</template>

<script>
import Polyglote from "@/services/polyglote";
import ChooseTable from "./modals/ChooseTable.vue";

export default {
  props: {
    sharedTime: Number,
    currentMode: {
      type: String,
      default: "none",
    },
  },
  data() {
    return {
      isMenuActive: false,
      menu: false,
      // isNavOpen:false,
      showTables: false,
      isActive: false,
      showLocale: false,
    };
  },
  methods: {
    emitDesktopNavigate(arg) {
      this.$emit("desktopNavigate", arg);
    },
    toggleMenu() {
      this.isMenuActive = !this.isMenuActive;
      this.$emit("menu", this.isMenuActive);
    },
    logout() {
      let userResponse = confirm(this.$t("logout.confirm"));
      const qId_cached = this.cafe.qId;
      if (userResponse) {
        this.$store.dispatch('logout');
        this.$router.push({
          name: 'link_login',
          params: {
            qid: qId_cached
          }
        });
      }
    },
    switchLocale(l) {
      this.$i18n.locale = l;
      Polyglote.updateLocale(l);
      moment.locale(this.$i18n.locale);

      this.toggleMenu();
    },
    localeShow() {
      this.showLocale = true;
    },
    toggleIntercom() {
      try {
        this.$store.dispatch('bootIntercom', {
          isDesktop: this.isDesktop
        });

        window.Intercom('show');
      } catch(ir) {
        console.error(`[IntercomInit] Error: `, ir);
      } 
      
    },
    openNewVersion() {
      window.localStorage.removeItem('no_new_version');
      window.location.href = `https://pos.qrwaiter.com.ua/login/${this.cafe.qId}`;
    }
  },
  components: {
    ChooseTable,
  },
  computed: {
    currentLocale() {
      return this.$i18n.locale;
    },
    cafe() {
      return this.$store.state.cafe;
    },
    waiter() {
      return this.$store.state.waiter;
    },
    preorderLinkString() {
      if (this.cafe.modes.delivery && this.cafe.modes.preorder) {
        return "TAKEAWAY / DELIVERY";
      }

      if (this.cafe.modes.preorder) return `TAKEAWAY`;
      if (this.cafe.modes.delivery) return `DELIVERY`;
    },
    pendingCounters() {
      let counters = {
        inside: 0,
        preorder: 0,
        delivery: 0,
        total: 0,
      };

      if (!this.cafe || !this.cafe.modes) return counters;

      counters.inside = this.$store.state.queue.orders.filter(
        (o) => o.status === "waiting" || o.status === "paying"
      ).length;
      if (this.cafe.modes.preorder) {
        counters.preorder = this.$store.state.preorder.preorders.filter(
          (o) => !o.is_delivery && o.status === "confirmed"
        ).length;
      }

      if (this.cafe.modes.delivery) {
        counters.delivery = this.$store.state.preorder.preorders.filter(
          (o) => o.is_delivery && o.status === "confirmed"
        ).length;
      }

      counters.total = counters.inside + counters.preorder;

      return counters;
    },
    isDesktop() {
      return window.innerWidth > 768;
    },
    notificationsCounter() {
      return 0;
    },
    isHotel() {
      return this.$store.getters.isHotel;
    },
    canShowTables() {
      if (!this.cafe || !this.cafe.modes) return false; 
      return !this.cafe.inside_lite && this.cafe.modes.inside;
    },
  },
};
</script>

<style scoped>
.otherLocale {
  display: inline-block;
}
.line {
  display: none;
}

@media (min-width: 767px) {
  .line {
    display: block;
    position: absolute;
    border-right: 0.111vh solid #fff;
    top: 1.111vh;
    right: 13vh;
    height: 4.4444vh;
  }
  .locale-image {
    width: 4vw !important;
    margin: 1vh 0 2vh !important;
  }
  .list {
    z-index: 1 !important;
    position: relative;
  }
  .box-alert.link {
    text-align: center;
    padding-left: 0.55vh !important;
    padding-right: 0.825vh !important;

    transform: none !important;
    height: auto !important;
    line-height: normal;
    font-size: 1.4vh !important;
    margin-right: 0;
  }

  .caffe-name-info {
    padding-right: 3.3333vh;
    padding-top: 0.8vh !important;
  }

  .timer {
    padding-left: 3.333vh;
    padding-right: 3.333vh;
    align-self: center;
    font-size: 2.2222vh;
  }

  .desktop-nav-info {
    display: flex !important;
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
  }

  .desktop-nav-info p,
  .desktop-nav-info h4 {
    padding: 0;
    margin: 0;
    text-align: right;
  }
  .desktop-nav-info h4 {
    font-weight: 500;
    font-size: 2.2222vh;

    color: #ededed;
  }
  .desktop-nav-info p {
    font-weight: 500;
    font-size: 2.2222vh;
    line-height: 2vh !important;
    color: #a4a3a1;
  }
  .list ul li {
    font-size: 2vh;
    margin-top: 0;
    line-height: 1.3;
    padding: 0.8vh 3.333vh 0.8vh 0;
    align-self: center;
  }
  .list ul {
    margin-left: 0;
  }
  .list {
    padding-left: 5.555vh;
    padding-top: 1.1111vh;
    padding-bottom: 1.1111vh;
    height: 6.666vh;
    position: relative !important;
    top: 0;
  }

  .list-logo {
    display: block;
    height: 4vh;
    width: 4vh;
    margin-right: 3vh;
    align-self: center;
    align-content: center;
    align-items: center;
  }
  .exit {
    display: none;
  }
  .locale-image-div {
    margin-top: 0 !important;

    align-content: center;
    align-items: center;
    align-self: center;
    /* padding-top: 1.5vh; */
  }

  .list-slide {
    /* opacity: 1; */
    /* animation:  */
    padding-left: 5.56vh !important;
    padding-top: 1.1111vh !important;
    padding-bottom: 1.1111vh !important;
    top: 0 !important;
    position: absolute !important;

  }
}

@keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}

@media (min-width: 300px) and (max-width: 1025px) {
  .nav-info {
    display: none !important;
  }
  .caffe-info {
    position: relative;
    transform: translateY(-5%);
    line-height: 0.8;
    margin-left: 2vh;
    display: inline-block;
  }
  .caffe-info h4 {
    font-size: 2.3vh;
  }
  .caffe-info span {
    font-size: 2vh;
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 28vh;
  }

  .list-logo {
    display: none;
  }
}

.box-alert {
  background: #e2223b;
  color: white;
  display: inline-block;
  padding: 0.3vh 1vh;
  line-height: 1.1;
  border-radius: 0.3vh;
  margin-top: 0vh;
  font-size: 2vh;

  margin-right: 1.4vw;
}

.box-alert.link {
  font-size: 3.2vw;
  transform: translateY(-20%);
  border-radius: 0.3vh;
  padding: 0.3vh 0.7vh;
}

.exit span {
  position: relative;
  margin-top: -3vh;
  display: block;
  font-size: 5.4vw;
  line-height: 0.8;
}

@media screen and (min-width: 1025px) {
   
  .caffe-info {
    padding-left: 1vh;
  }
  .cafe-logo {
    display: none;
  }

  .nav-info .caffe-name {
    position: absolute;
    top: 5px;
    right: 80px;
    font-weight: 500;
    color: white;
  }
  .nav-info .queue {
    top: 23px;
    position: absolute;
    right: 80px;
    font-weight: 500;
    color: #b7b7b7;
  }
  .nav-info .tick {
    position: absolute;
    right: 5px;
    padding: 2px 10px;
    margin-top: 12px;
    border-left: 1px solid grey;
    height: 30px;
    color: white;
  }

  .menu-list,
  .waiter,
  .cafe {
    display: none;
  }
  span {
    float: right;
  }
  img.locale-image {
    margin: 0 !important;
    margin-right: 1.666vh !important;
    cursor: pointer;
    width: 3.3333vh !important;
    height: 3.3333vh;
    transition: 0.3s;
  }
  img.locale-image:hover {
    opacity: 0.6;
  }
  .list {
    z-index: -1;
    border-radius: 0 !important;
    margin-top: 0 !important;
  }
  .list,
  .list-slide {
    display: flex !important;
    opacity: 1 !important;
    top: 0px !important;
  }
  ul {
    display: flex;
    padding-top: 0 !important;
    margin-bottom: 0;
  }
  li {
    cursor: pointer;
    transition: 0.3s;
    padding: 10px 20px 10px 0px;
  }
  li:hover {
    /* color: #868686; */
    color: #a4a3a1;
  }

  .box-alert.link {
    font-size: 1.51vh !important;
    padding-right: 0 !important;
    transform: none;
    height: auto !important;
    padding-left: 0 !important;
    padding: 0.1vh 0.7vh !important;
  }
}

.router-link-active {
  color: #ededed;
}

.desktop-nav-info {
  display: none;
}

.v-center {
  align-self: center;
  height: fit-content;
}

.v-center.circle {
  height: 4.5vh;
  width: 4.5vh;
  transform: translateY(0);
  float: right;
}

.circle .cafe-logo {
  width: 100%;
  border-radius: 10vh;
  height: 100%;
  object-fit: cover;
}

.select-language {
  box-shadow: 0px 0px 5px #dddddd;
  border-radius: 40px;
  display: block;
  background: white;
  margin: 0 auto;
  width: 90%;
  text-align: center;
  left: 0;
  right: 0;
  transform: translateY(30%);
  overflow-y: auto;
  padding: 20px 0;
  position: absolute;
}

.list {
  background: #1d1d1b;
  font-size: 18px;
  top: -20vh;
   height: 0;
  transition: 0.3s;
  line-height: 35px;
  opacity: 0;
  width: 100%;
  position: fixed;
  color: white;
  border-radius: 0 0 35px 35px;
}

.list-slide {
  height: auto;
  /* opacity: 1; */
  z-index: 3;
  padding: 0.1vh 5.4vw 2.5vh;
  top: 6.5vh !important;
  height: auto;
  position: fixed !important;
  animation: fadein 0.3s forwards;
}

.select-language h4 {
  font-size: 20px;
  position: initial;
  color: #000;
  text-align: center;
  margin: 2px 0 20px;
}

.select-language img {
  height: 110px;
}

ul {
  list-style-type: none;
  padding-left: 0;
  margin-bottom: 0;
}

.menu-list {
  height: 2.5vh;
  z-index: 50;
  width: auto;
  transform: scaleX(-1);
}

li {
  font-size: 5.4vw;
  margin-top: 3.1vh;
  line-height: 0.8;
}

.queue-navbar {
  display: flex;
  justify-content: space-between;
  padding: 1.6vh 5.4vw;
  z-index: 5;
  align-items: baseline;
  background-color: #1d1d1b;
  position: fixed;
  height: auto;
  width: 100%;
}

.hide-content {
  height: 100%;
  width: 100%;
  position: fixed;
  overflow: hidden;
  background: #868686;
  opacity: 0.9;
  top: 0;
  left: 0;
}

.locale-image {
  height: auto;
  margin: 0 2.7vw 0 0;
  width: 8vw;
}

.tables img {
  position: relative;
  top: 10px;
}

.cafe-right {
  height: 9vw;
  position: relative;
}

.desktop-dark {
  color: #868686;
}

.active-link {
  color: #ededed !important;
}
</style>
